import analyticsIcon from "../assets/icons/navIcons/analyticsIcon.svg";
import dashboardIcon from "../assets/icons/navIcons/dashboardIcon.svg";
import languageIcon from "../assets/icons/navIcons/languageIcon.svg";
import layoutIcon from "../assets/icons/navIcons/layoutIcon.svg";
import categoriesIcon from "../assets/icons/navIcons/categoriesIcon.svg";
import userIcon from "../assets/icons/navIcons/userIcon.svg";
import videosIcon from "../assets/icons/navIcons/videosIcon.svg";
import curriculumIcon from "../assets/icons/navIcons/curriculumIcon.svg";
import testimonialsIcon from "../assets/icons/navIcons/testimonialsIcon.svg";
import givingsIcon from "../assets/icons/navIcons/givingsIcon.svg";
import notificationsListIcon from "../assets/icons/navIcons/notificationsListIcon.svg";
import prayersIcon from "../assets/icons/navIcons/prayersIcon.svg";
import feedbackIcon from "../assets/icons/navIcons/feedbackIcon.svg";
import testimonialsCategoryIcon from "../assets/icons/navIcons/testimonialsCategoryIcon.svg";
import testimonialsCategoryHoverIcon from "../assets/icons/navIcons/testimonialsCategoryHoverIcon.svg";
import feedbackHoverIcon from "../assets/icons/navIcons/feedbackHoverIcon.svg";
import twgIcon from "../assets/icons/navIcons/twgIcon.svg";
import twgHoverIcon from "../assets/icons/navIcons/twgHoverIcon.svg";
import ChurchIcon from '../assets/icons/church.png'
import ChannelIcon from '../assets/icons/navIcons/channelsIcon.svg'
import MinistryIcon from "../assets/icons/navIcons/MinistryIcon.svg"

export const ChannelFieldTabsIconArray = [
  { icon: dashboardIcon, route: "/channels", title: "Dashboard" },
  { icon: ChannelIcon, route: "/addChannelField?tab=Channels", title: "Channels" },
  { icon: categoriesIcon, route: "/addChannelField?tab=Image%20Gallery", title: "Image Gallery" },
  { icon: categoriesIcon, route: "/addChannelField?tab=Cover%20Image", title: "Cover Image" },
  { icon: videosIcon, route: "/addChannelField?tab=Video%20Gallery", title: "Video Gallery" },
  { icon: videosIcon, route: "/addChannelField?tab=Cover%20Video", title: "Cover Video" },
  { icon: layoutIcon, route: "/addChannelField?tab=Services", title: "Services" },
  { icon: userIcon, route: "/addChannelField?tab=Leadership%20Team", title: "Leadership Team" },
  { icon: testimonialsIcon, route: "/addChannelField?tab=Programs", title: "Programs" },
  { icon: curriculumIcon, route: "/addChannelField?tab=Curriculum", title: "Curriculum" },
  { icon: twgIcon, route: "/addChannelField?tab=Journals", title: "Journals" },
  { icon: prayersIcon, route: "/addChannelField?tab=Prayer", title: "Prayer" },
  { icon: layoutIcon, route: "/addChannelField?tab=Plan", title: "Plan" },
  { icon: curriculumIcon, route: "/addChannelField?tab=Sermon%20Plans", title: "Sermon Plans" },
  { icon: notificationsListIcon, route: "/addChannelField?tab=Notifications", title: "Notifications" },
];

export const ChurchFieldTabsIconArray = [
  { icon: dashboardIcon, route: "/churches", title: "Dashboard" },
  { icon: ChurchIcon, route: "/addfield?tab=Churches", title: "Churches" },
  { icon: categoriesIcon, route: "/addfield?tab=Image%20Gallery", title: "Image Gallery" },
  { icon: categoriesIcon, route: "/addfield?tab=Cover%20Image", title: "Cover Image" },
  { icon: videosIcon, route: "/addfield?tab=Video%20Gallery", title: "Video Gallery" },
  { icon: videosIcon, route: "/addfield?tab=Church%20Video", title: "Church Video" },
  { icon: testimonialsCategoryIcon, route: "/addfield?tab=Circle", title: "Circle" },
  { icon: notificationsListIcon, route: "/addfield?tab=Notifications", title: "Notifications" },
  { icon: userIcon, route: "/addfield?tab=Groups", title: "Groups" },
  { icon: layoutIcon, route: "/addfield?tab=Plan", title: "Plan" },
  { icon: userIcon, route: "/addfield?tab=Leadership%20Team", title: "Leadership Team" },
  { icon: categoriesIcon, route: "/addfield?tab=Resources", title: "Resources" },
  { icon: testimonialsCategoryIcon, route: "/addfield?tab=Carecells", title: "Carecells" },
  { icon: testimonialsIcon, route: "/addfield?tab=Programs", title: "Programs" },
  { icon: categoriesIcon, route: "/addfield?tab=Bulletins", title: "Bulletins" },
  { icon: layoutIcon, route: "/addfield?tab=Campuses", title: "Campuses" },
  { icon: layoutIcon, route: "/addfield?tab=Services", title: "Services" },
  { icon: prayersIcon, route: "/addfield?tab=Prayer", title: "Prayer" },
  { icon: curriculumIcon, route: "/addfield?tab=Curriculum", title: "Curriculum" },
  { icon: curriculumIcon, route: "/addfield?tab=Sermon%20Plans", title: "Sermon Plans" },
  { icon: twgIcon, route: "/addfield?tab=Journals", title: "Journals" },
];

export const MinistryFieldTabsIconArray = [
  { icon: dashboardIcon, route: "/ministry", title: "Dashboard" },
  { icon: MinistryIcon, route: "/addMinistryField?tab=Ministries", title: "Ministries" },
  { icon: categoriesIcon, route: "/addMinistryField?tab=Image%20Gallery", title: "Image Gallery" },
  { icon: categoriesIcon, route: "/addMinistryField?tab=Cover%20Image", title: "Cover Image" },
  { icon: videosIcon, route: "/addMinistryField?tab=Video%20Gallery", title: "Video Gallery" },
  { icon: videosIcon, route: "/addMinistryField?tab=Cover%20Video", title: "Cover Video" },
  { icon: userIcon, route: "/addMinistryField?tab=Leadership%20Team", title: "Leadership Team" },
  { icon: testimonialsIcon, route: "/addMinistryField?tab=Programs", title: "Programs" },
  { icon: curriculumIcon, route: "/addMinistryField?tab=Curriculum", title: "Curriculum" },
  { icon: twgIcon, route: "/addMinistryField?tab=Journals", title: "Journals" },
  { icon: prayersIcon, route: "/addMinistryField?tab=Prayer", title: "Prayer" },
  { icon: layoutIcon, route: "/addMinistryField?tab=Plan", title: "Plan" },
  { icon: curriculumIcon, route: "/addMinistryField?tab=Sermon%20Plans", title: "Sermon Plans" },
  { icon: notificationsListIcon, route: "/addMinistryField?tab=Notifications", title: "Notifications" },
];
export const iconArray = [
  {
    icon: analyticsIcon,
    route: "/analytics",
    title: "Analytics",
  },
  {
    icon: dashboardIcon,
    route: "/",
    title: "Dashboard",
  },
  {
    icon: layoutIcon,
    route: "/layout",
    title: "Layouts",
  },
  {
    icon: languageIcon,
    route: "/languages",
    title: "Languages",
  },
  {
    icon: userIcon,
    route: "/users",
    title: "Users",
  },
  {
    icon: videosIcon,
    route: "/videos",
    title: "Videos",
  },
  {
    icon: layoutIcon,
    route: "/plans",
    title: "Plans",
  },
  {
    icon: curriculumIcon,
    route: "/sermon-plans",
    title: "Sermon Plans",
  },
  {
    icon: categoriesIcon,
    route: "/categories",
    title: "Categories",
  },
  {
    icon: categoriesIcon,
    route: "/agreements",
    title: "Agreements",
  },
  

  {
    icon: curriculumIcon,
    route: "/curriculum",
    title: "Curriculum",
  },
  {
    icon: testimonialsCategoryIcon,
    hover: testimonialsCategoryHoverIcon,
    route: "/testimonycategory",
    title: "Testimony Category",
  },
  {
    icon: testimonialsIcon,
    route: "/testimonials",
    title: "Testimonials",
  },
  {
    icon: givingsIcon,
    route: "/givings",
    title: "Givings",
  },
  {
    icon: notificationsListIcon,
    route: "/notificationsList",
    title: "Notifications List",
  },
  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/twg",
    title: "Today With God",
  },
  {
    icon: prayersIcon,
    route: "/prayers",
    title: "Prayers",
  },
  {
    icon: feedbackIcon,
    hover: feedbackHoverIcon,
    route: "/feedback",
    title: "Feedback",
  },

];
export const TWGIconArray = [
  {
    icon: analyticsIcon,
    route: "/analytics",
    title: "Analytics",
  },
  {
    icon: dashboardIcon,
    route: "/",
    title: "Dashboard",
  },
  {
    icon: layoutIcon,
    route: "/layout",
    title: "Layouts",
  },
  {
    icon: languageIcon,
    route: "/languages",
    title: "Languages",
  },
  {
    icon: userIcon,
    route: "/users",
    title: "Users",
  },
  {
    icon: ChurchIcon,
    route: "/churches",
    title: "Churches",
  },
  {
    icon: ChannelIcon,
    route: "/channels",
    title: "Channels",
  },
  {
    icon: MinistryIcon,
    route: "/ministry",
    title: "Ministries",
  },
  {
    icon: videosIcon,
    route: "/videos",
    title: "Videos",
  },
  {
    icon: layoutIcon,
    route: "/plans",
    title: "Plans",
  },
  {
    icon: curriculumIcon,
    route: "/sermon-plans",
    title: "Sermon Plans",
  },
  {
    icon: categoriesIcon,
    route: "/categories",
    title: "Categories",
  },
  {
    icon: categoriesIcon,
    route: "/agreements",
    title: "Agreements",
  },
  

  {
    icon: curriculumIcon,
    route: "/curriculum",
    title: "Curriculum",
  },
  {
    icon: testimonialsCategoryIcon,
    hover: testimonialsCategoryHoverIcon,
    route: "/testimonycategory",
    title: "Testimony Category",
  },
  {
    icon: testimonialsIcon,
    route: "/testimonials",
    title: "Testimonials",
  },
  {
    icon: categoriesIcon,
    route: "/speakers",
    title: "Journal Speakers",
  },
  {
    icon: categoriesIcon,
    route: "/jcategory",
    title: "Journal Categories",
  },
  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/twg",
    title: "TWG Journal",
  },
  {
    icon: givingsIcon,
    route: "/givings",
    title: "Givings",
  },
  {
    icon: notificationsListIcon,
    route: "/notificationsList",
    title: "Notifications List",
  },
  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/twg",
    title: "Daily Devotion",
  },
  {
    icon: prayersIcon,
    route: "/prayers",
    title: "Prayers",
  },
  {
    icon: feedbackIcon,
    hover: feedbackHoverIcon,
    route: "/feedback",
    title: "Feedback",
  },

];
export const ChurchesIconArray = [
  {
    icon: analyticsIcon,
    route: "/analytics",
    title: "Analytics",
  },
  {
    icon: dashboardIcon,
    route: "/",
    title: "Dashboard",
  },
  {
    icon: layoutIcon,
    route: "/layout",
    title: "Layouts",
  },
 
  {
    icon: userIcon,
    route: "/users",
    title: "Users",
  },
  {
    icon: testimonialsIcon,
    route: "/programs",
    title: "Programs",
  },
  {
    icon: dashboardIcon,
    route: "/events",
    title: "Events",
  },
  {
  icon: testimonialsCategoryIcon,
  route: "/carecells",
  title: "Carecells",
},
 
  {
    icon: twgIcon,
    route: "/campus",
    title: "Campus",
  },
  {
    icon: prayersIcon,
    route: "/teams",
    title: "Teams",
  },
  {
    icon: ChurchIcon,
    route: "/addfield",
    title: "Churches",
  },
  {
    icon: ChannelIcon,
    route: "/channels",
    title: "Channels",
  },
  {
    icon: MinistryIcon,
    route: "/ministry",
    title: "Ministries",
  },
  {
    icon: videosIcon,
    route: "/videos",
    title: "Videos",
  },
  {
    icon: layoutIcon,
    route: "/plans",
    title: "Plans",
  },
  {
    icon: curriculumIcon,
    route: "/sermon-plans",
    title: "Sermon Plans",
  },
  {
    icon: categoriesIcon,
    route: "/categories",
    title: "Categories",
  },
  

  {
    icon: curriculumIcon,
    route: "/curriculum",
    title: "Curriculum",
  },
  {
    icon: testimonialsCategoryIcon,
    hover: testimonialsCategoryHoverIcon,
    route: "/testimonycategory",
    title: "Testimony Category",
  },
  {
    icon: testimonialsIcon,
    route: "/testimonials",
    title: "Testimonials",
  },
 
  {
    icon: categoriesIcon,
    route: "/speakers",
    title: "Journal Speakers",
  },
  {
    icon: categoriesIcon,
    route: "/jcategory",
    title: "Journal Categories",
  },
  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/twg",
    title: "TWG Journal",
  },
 
  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/devotion",
    title: "Daily Devotion",
  },
  {
    icon: prayersIcon,
    route: "/prayers",
    title: "Prayers",
  },


];
export const ChannelsIconArray = [
  {
    icon: analyticsIcon,
    route: "/analytics",
    title: "Analytics",
  },
  {
    icon: dashboardIcon,
    route: "/",
    title: "Dashboard",
  },
  {
    icon: layoutIcon,
    route: "/layout",
    title: "Layouts",
  },

  {
    icon: userIcon,
    route: "/users",
    title: "Users",
  },
  {
    icon: testimonialsIcon,
    route: "/programs",
    title: "Programs",
  },
  {
    icon: dashboardIcon,
    route: "/events",
    title: "Events",
  },
  {
    icon: testimonialsCategoryIcon,
    route: "/carecells",
    title: "Carecells",
  },
  {
    icon: twgIcon,
    route: "/campus",
    title: "Campus",
  },
  {
    icon: prayersIcon,
    route: "/teams",
    title: "Teams",
  },
  {
    icon: ChannelIcon,
    route: "/channels",
    title: "Channels",
  },

  {
    icon: videosIcon,
    route: "/videos",
    title: "Videos",
  },
  {
    icon: layoutIcon,
    route: "/plans",
    title: "Plans",
  },
  {
    icon: curriculumIcon,
    route: "/sermon-plans",
    title: "Sermon Plans",
  },
  {
    icon: categoriesIcon,
    route: "/categories",
    title: "Categories",
  },
  

  {
    icon: curriculumIcon,
    route: "/curriculum",
    title: "Curriculum",
  },
  {
    icon: testimonialsCategoryIcon,
    hover: testimonialsCategoryHoverIcon,
    route: "/testimonycategory",
    title: "Testimony Category",
  },
  {
    icon: testimonialsIcon,
    route: "/testimonials",
    title: "Testimonials",
  },

  {
    icon: categoriesIcon,
    route: "/speakers",
    title: "Journal Speakers",
  },
  {
    icon: categoriesIcon,
    route: "/jcategory",
    title: "Journal Categories",
  },
  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/twg",
    title: "TWG Journal",
  },

  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/devotion",
    title: "Daily Devotion",
  },
  {
    icon: prayersIcon,
    route: "/prayers",
    title: "Prayers",
  },


];
export const MinistriesIconArray = [
  {
    icon: analyticsIcon,
    route: "/analytics",
    title: "Analytics",
  },
  {
    icon: dashboardIcon,
    route: "/",
    title: "Dashboard",
  },
  {
    icon: layoutIcon,
    route: "/layout",
    title: "Layouts",
  },

  {
    icon: userIcon,
    route: "/users",
    title: "Users",
  },
  {
    icon: testimonialsIcon,
    route: "/programs",
    title: "Programs",
  },
  {
    icon: dashboardIcon,
    route: "/events",
    title: "Events",
  },
  {
    icon: testimonialsCategoryIcon,
    route: "/carecells",
    title: "Carecells",
  },
  {
    icon: twgIcon,
    route: "/campus",
    title: "Campus",
  },
  {
    icon: prayersIcon,
    route: "/teams",
    title: "Teams",
  },
  {
    icon: ChannelIcon,
    route: "/channels",
    title: "Channels",
  },
  {
    icon: MinistryIcon,
    route: "/ministry",
    title: "Ministries",
  },
  {
    icon: videosIcon,
    route: "/videos",
    title: "Videos",
  },
  {
    icon: layoutIcon,
    route: "/plans",
    title: "Plans",
  },
  {
    icon: curriculumIcon,
    route: "/sermon-plans",
    title: "Sermon Plans",
  },
  {
    icon: categoriesIcon,
    route: "/categories",
    title: "Categories",
  },
  

  {
    icon: curriculumIcon,
    route: "/curriculum",
    title: "Curriculum",
  },
  {
    icon: testimonialsCategoryIcon,
    hover: testimonialsCategoryHoverIcon,
    route: "/testimonycategory",
    title: "Testimony Category",
  },
  {
    icon: testimonialsIcon,
    route: "/testimonials",
    title: "Testimonials",
  },

  {
    icon: categoriesIcon,
    route: "/speakers",
    title: "Journal Speakers",
  },
  {
    icon: categoriesIcon,
    route: "/jcategory",
    title: "Journal Categories",
  },
  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/twg",
    title: "TWG Journal",
  },

  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/devotion",
    title: "Daily Devotion",
  },
  {
    icon: prayersIcon,
    route: "/prayers",
    title: "Prayers",
  },


];

export const churchPortalOnlyIconArray = [
  {
    icon: ChurchIcon,
    route: "/churches",
    title: "Churches",
  },
];

export const channelPortalOnlyIconArray = [
  {
    icon: ChannelIcon,
    route: "/channels",
    title: "Channels",
  },
];

export const ministryPortalOnlyIconArray = [
  {
    icon: MinistryIcon,
    route: "/ministry",
    title: "Ministries",
  },
];

export const entityPortalsOnlyIconArray = [
  {
    icon: ChurchIcon,
    route: "/churches",
    title: "Churches",
  },
  {
    icon: ChannelIcon,
    route: "/channels",
    title: "Channels",
  },
  {
    icon: MinistryIcon,
    route: "/ministry",
    title: "Ministries",
  },
];

export const superAdminIconArray = [
  {
    icon: analyticsIcon,
    route: "/analytics",
    title: "Analytics",
  },
  {
    icon: dashboardIcon,
    route: "/",
    title: "Dashboard",
  },
  {
    icon: languageIcon,
    route: "/languages",
    title: "Languages",
  },
  {
    icon: layoutIcon,
    route: "/layout",
    title: "Layouts",
  },
  {
    icon: categoriesIcon,
    route: "/categories",
    title: "Categories",
  },
  {
    icon: userIcon,
    route: "/users",
    title: "Users",
  },
  {
    icon: videosIcon,
    route: "/videos",
    title: "Videos",
  },
  {
    icon: layoutIcon,
    route: "/plans",
    title: "Plans",
  },
  {
    icon: curriculumIcon,
    route: "/sermon-plans",
    title: "Sermon Plans",
  },
  {
    icon: curriculumIcon,
    route: "/curriculum",
    title: "Curriculum",
  },
  {
    icon: testimonialsIcon,
    route: "/testimonials",
    title: "Testimonials",
  },
  {
    icon: givingsIcon,
    route: "/givings",
    title: "Givings",
  },
  {
    icon: notificationsListIcon,
    route: "/notificationsList",
    title: "Notifications List",
  },
  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/twg",
    title: "Today With God",
  },
  {
    icon: prayersIcon,
    route: "/prayers",
    title: "Prayers",
  },
  {
    icon: feedbackIcon,
    hover: feedbackHoverIcon,
    route: "/feedback",
    title: "Feedback",
  },
  {
    icon: testimonialsCategoryIcon,
    hover: testimonialsCategoryHoverIcon,
    route: "/testimonycategory",
    title: "Testimony Category",
  },
];

export const cmsAdminIconArray = [
  {
    icon: dashboardIcon,
    route: "/",
    title: "Dashboard",
  },
  {
    icon: languageIcon,
    route: "/languages",
    title: "Languages",
  },
  {
    icon: layoutIcon,
    route: "/layout",
    title: "Layouts",
  },
  {
    icon: categoriesIcon,
    route: "/categories",
    title: "Categories",
  },
  {
    icon: userIcon,
    route: "/users",
    title: "Users",
  },
  {
    icon: videosIcon,
    route: "/videos",
    title: "Videos",
  },
  {
    icon: layoutIcon,
    route: "/plans",
    title: "Plans",
  },
  {
    icon: curriculumIcon,
    route: "/sermon-plans",
    title: "Sermon Plans",
  },
  {
    icon: curriculumIcon,
    route: "/curriculum",
    title: "Curriculum",
  },
  {
    icon: testimonialsIcon,
    route: "/testimonials",
    title: "Testimonials",
  },
 
 
  {
    icon: twgIcon,
    hover: twgHoverIcon,
    route: "/twg",
    title: "Today With God",
  },
  {
    icon: givingsIcon,
    route: "/givings",
    title: "Givings",
  },
  {
    icon: notificationsListIcon,
    route: "/notificationsList",
    title: "Notifications List",
  },
  {
    icon: prayersIcon,
    route: "/prayers",
    title: "Prayers",
  },
  {
    icon: feedbackIcon,
    hover: feedbackHoverIcon,
    route: "/feedback",
    title: "Feedback",
  },
  {
    icon: testimonialsCategoryIcon,
    hover: testimonialsCategoryHoverIcon,
    route: "/testimonycategory",
    title: "Testimony Category",
  },
];

export const testimonialAdminIconArray = [
  {
    icon: testimonialsIcon,
    route: "/testimonials",
    title: "Testimonials",
  },
  {
    icon: userIcon,
    route: "/users",
    title: "Users",
  },
];

export const curriculumAdminIconArray = [
  {
    icon: curriculumIcon,
    route: "/curriculum",
    title: "Curriculum",
  },
  {
    icon: userIcon,
    route: "/users",
    title: "Users",
  },
];

export const navActiveCss = "bg-yellowish rounded-lg custom-stroke-black";
export const navHoverCss =
  "hover:bg-yellowish rounded-lg  custom-hover-stroke-black custom-stroke-grey";
